import useSWR from 'swr';

import { getCustomersWithPendingOrders } from '../../../models';
import { CUSTOMER_TYPE_VALUES, getInvoiceFrequencyName } from '../../../../customer/select-values';
import { useCreateInvoiceCtx } from './context';
import { EmptyState } from '../../../../../components/empty-state/EmptyState';

export interface ICustomerSelectProps {
  searchValue: string;
  dateFrom: string;
  dateTo: string;
  invoiceFrequency?: 'TRANSPORT' | 'WEEKLY' | 'MONTHLY';
}

export const CustomerSelect: React.FC<ICustomerSelectProps> = (props) => {
  const { searchValue, dateFrom, dateTo, invoiceFrequency } = props;
  const { dispatch } = useCreateInvoiceCtx();
  const { data: customers } = useSWR(
    ['customers-with-pending-orders', searchValue, dateFrom, dateTo, invoiceFrequency],
    () =>
      getCustomersWithPendingOrders({
        query: searchValue || undefined,
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        invoiceFrequency,
      }),
  );

  if (!customers?.length) {
    return <EmptyState title="Geen klanten met openstaande orders gevonden." />;
  }

  const totals = customers.reduce(
    (acc, c) => ({
      pendingOrders: acc.pendingOrders + c.pendingOrders,
      pendingCmrOrders: acc.pendingCmrOrders + c.pendingCmrOrders,
    }),
    { pendingOrders: 0, pendingCmrOrders: 0 },
  );

  return (
    <div>
      <div className="grid gap-4 lg:grid-cols-2 xl:grid-cols-3">
        {customers
          .sort((a, b) => b.pendingOrders - a.pendingOrders)
          .map((c) => {
            return (
              <div
                key={c.customer.id}
                className="card p-4"
                data-clickable="true"
                onClick={() => {
                  dispatch({
                    type: 'SELECT_CUSTOMER',
                    customer: c,
                  });
                }}
              >
                <div className="flex justify-between">
                  <div className="card-heading-text">{c.customer.name}</div>
                  <div className="card-subtle-text">{c.customer.vatNumber}</div>
                </div>

                <div className="card-subtle-text mb-1">
                  {CUSTOMER_TYPE_VALUES.find((v) => v.key === c.customer.type)?.name}
                </div>

                <div className="card-subtle-text mb-4">
                  Facturatiefrequentie: {getInvoiceFrequencyName(c.customer.invoiceFrequency)}
                </div>

                <div>{`${c.customer.street} ${c.customer.streetNumber}`}</div>
                <div>{`${c.customer.postalCode} ${c.customer.city}, ${c.customer.country}`}</div>

                <div className="font-medium mt-2 text-brand-text">
                  {c.pendingOrders} openstaande orders ({c.pendingCmrOrders} met CMR)
                </div>
              </div>
            );
          })}
      </div>

      <div className="my-4">
        {`Totaal: ${totals.pendingOrders} openstaande orders (${totals.pendingCmrOrders} met CMR)`}
      </div>
    </div>
  );
};
